import { computeFunction } from 'services';

export const getEv = computeFunction(
  (marketCap, netDept) => marketCap + netDept
);

export const getLtmMultiples = computeFunction((ev, ltm) => ev / ltm);

export const getNtmMultiples = computeFunction((ev, ntm) => ev / ntm);
